/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_AccentsInputs */

const en_us2_search_accents = /** @type {(inputs: Search_AccentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accents don't matter`)
};

const pt_br2_search_accents = /** @type {(inputs: Search_AccentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acentos não importam`)
};

const es_419_search_accents = /** @type {(inputs: Search_AccentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Los acentos no importan`)
};

const pt_pt2_search_accents = /** @type {(inputs: Search_AccentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Os acentos não importam`)
};

const fr_fr2_search_accents = /** @type {(inputs: Search_AccentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les accents ne comptent pas`)
};

const de_de2_search_accents = /** @type {(inputs: Search_AccentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Umlaute sind egal`)
};

const it_it2_search_accents = /** @type {(inputs: Search_AccentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gli accenti non contano`)
};

/**
* | output |
* | --- |
* | "Accents don't matter" |
*
* @param {Search_AccentsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const search_accents = /** @type {((inputs?: Search_AccentsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_AccentsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_search_accents(inputs)
	if (locale === "es-419") return es_419_search_accents(inputs)
	if (locale === "pt-PT") return pt_pt2_search_accents(inputs)
	if (locale === "fr-FR") return fr_fr2_search_accents(inputs)
	if (locale === "de-DE") return de_de2_search_accents(inputs)
	if (locale === "it-IT") return it_it2_search_accents(inputs)
	return en_us2_search_accents(inputs)
});
export { search_accents as "search.accents" }